import createIcon from '../../createIcon';

/**
 * @component @name HourglassTop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyTDYuMDEgOEwxMCAxMkw2LjAxIDE2LjAxTDYgMjJIMThWMTZMMTQgMTJMMTggOC4wMVYySDZaTTE2IDE2LjVWMjBIOFYxNi41TDEyIDEyLjVMMTYgMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassTop = createIcon('HourglassTop', [
  [
    'path',
    {
      d: 'M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z',
      key: '1ydnzm',
    },
  ],
]);

export default HourglassTop;
